module.exports = __webpack_public_path__ + "img/transportation-dashboard-icon.9a877e0.png";